/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Local types
import { RedactEntity, Resource } from '@app-types/blackroom-api';
import { DialogProps } from '@features/Dialog/types';

/* -------------------------------------------------------------------------- */
/*                                    Types                                   */
/* -------------------------------------------------------------------------- */

export interface DialogRedactionProps extends DialogProps {
  resourcesToRedact: Pick<
    Resource,
    | 'id'
    | 'type'
    | 'name'
    | 'isFavorite'
    | 'pspdfKitId'
    | 'workspaceId'
    | 'size'
  >[];
}

export const dialogRedactionSteps = ['search', 'results'] as const;

export type DialogRedactionSteps = (typeof dialogRedactionSteps)[number];

export type DialogSearchInlineFormSchema = {
  keywords?: string[];
  entities?: RedactEntity[];
};
